<template>
  <div class="user">
    <div class="photo">
      <i class="fas fa-user"></i>
    </div>
    <div class="info">
      <a data-toggle="collapse" @click="toggleMenu" href="javascript:void(0)">
           <span>
             {{ user.first_name }} {{ user.last_name }}<br/>
              <small>{{ user.email }}</small>
              <div style="padding-left:50px">{{ user.credits }} {{ $t("credits") }}</div>
             <b class="caret"></b>
          </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <el-collapse-transition>
          <ul class="nav" v-show="!isClosed">
            <li>
              <router-link to="/portal/edit-profile" tag="a">
                <span class="sidebar-mini"><i class="fas fa-address-card"></i></span>
                <span class="sidebar-normal">{{ $t("my_profile") }}</span>
              </router-link>
            </li>
          </ul>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
  export default {
    components: {
      [CollapseTransition.name]: CollapseTransition
    },
    data () {
      return {
        user: {},
        isClosed: true,
        avatar: null
      }
    },
    methods: {
      toggleMenu () {
        this.isClosed = !this.isClosed
      },
      loadAvatar() {
        var avatar = Ls.get('auth.user.avatar');
        if(avatar) {
          this.avatar = avatar
        }
      }
    },
    mounted () {
      this.user = Webservice.getUser().then(response => {
            if(response.data) {
                this.user = response.data;
            }
      });
      this.loadAvatar();
    },
    computed: {
      auth: () => { return Auth; },
      ws: () => { return Webservice; }
    }
  }
</script>
<style>
  .collapsed {
    transition: opacity 1s;
  }
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/UserMenu.vue